export default "__VITE_ASSET__Bh975TIt__"